import { Inject, Injectable, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableService } from "src/app/_metronic/shared/crud-table";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Category } from "../models/category.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CategoriesService
  extends TableService<Category>
  implements OnDestroy
{
  BASE_URL = environment.apiUrl;
  GET_ALL_URL = "Category";
  GET_ONE_URL = "Category";
  CREATE_URL = "Category";
  UPDATE_URL = "Category";
  DELETE_URL = "Category";

  constructor(
    @Inject(HttpClient) http,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(http, router, activatedRoute);
  }

  getAllCategories(): Observable<Category[]> {
    return this.request(environment.apiUrl + "/Category/GetAll").pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  getParentsCategories(): Observable<Category[]> {
    return this.request(environment.apiUrl + "/Category/GetParents").pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getCategories() {
    let params = new HttpParams();
    params = params.append("pageSize", 1000);
    return this.http.get(`${environment.apiUrl}/${this.GET_ALL_URL}`, {
      params,
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
